import React, {useState, useEffect} from 'react';
import {Navigate} from 'react-router-dom';
import {authenticationCheck} from "../../utils/auth";

const PrivateCheck = ({children}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            const authStatus = await authenticationCheck();
            setIsAuthenticated(authStatus);
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        // Show loading or a spinner while authentication check is in progress
        return <div></div>;
    }
    return isAuthenticated ? children : <Navigate to="/auth"/>;
};

export default PrivateCheck;
